const socialOptions = [
  { value: "facebook", label: "Facebook" },
  { value: "instagram", label: "Instagram" },
  { value: "linkedin", label: "Linkedin" },
  { value: "tiktok", label: "TikTok" }
];

export default socialOptions;
